import { useDispatch, useSelector } from 'react-redux'
import { CommonModals } from '../types/enums'
import { RootState } from '../../store/store'
import { selectModalState, setCommonModalState } from '../../store/slices/commonModalSlice'
import { useCallback } from 'react'

export const useCommonLoader = () => {
  const dispatch = useDispatch()

  const commonLoading = useSelector((state: RootState) =>
    selectModalState(state, CommonModals.LOADER),
  )
  const showCommonLoader = useCallback(async () => {
    dispatch(setCommonModalState({ modal: CommonModals.LOADER, state: true }))
  }, [dispatch])
  const hideCommonLoader = useCallback(async () => {
    dispatch(setCommonModalState({ modal: CommonModals.LOADER, state: false }))
  }, [dispatch])

  return { commonLoading, showCommonLoader, hideCommonLoader }
}
